import { useState, type FormEvent } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import {
  authEnabled,
  confirmSignUp,
  resendConfirmationCode,
  translateCognitoError,
} from '../../auth/auth';
import { sanitizeReturnTo, withReturnTo } from '../../lib/returnTo';

export default function Verify() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  // サインアップ画面から引き継いだ復帰先。確認後のログイン画面へさらに引き継ぐ。
  const from = sanitizeReturnTo(searchParams.get('from'));
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  // 認証未設定（モックモード）ではこの画面自体を表示しない。
  if (!authEnabled) return <Navigate to="/" replace />;
  // メールアドレスが無いとどのユーザーの確認かわからないため、サインアップからやり直させる。
  if (!email) return <Navigate to={withReturnTo('/signup', from)} replace />;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await confirmSignUp(email, code);
      navigate(withReturnTo('/login?signup=success', from));
    } catch (err) {
      setError(translateCognitoError(err));
      setBusy(false);
    }
  };

  const onResend = async () => {
    if (resending) return;
    setResending(true);
    setError('');
    setResent(false);
    try {
      await resendConfirmationCode(email);
      setResent(true);
    } catch (err) {
      setError(translateCognitoError(err));
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-card__title">メールアドレスの確認</h1>
        <p className="auth-card__lead">
          {email} に確認コードを送りました。届いた 6 桁のコードを入力してください。
        </p>

        {resent && <div className="auth-form__success">確認コードを再送しました。</div>}

        <form className="auth-form" onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="code">確認コード</label>
            <input
              id="code"
              inputMode="numeric"
              autoComplete="one-time-code"
              required
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          {error && <div className="auth-form__error">{error}</div>}

          <button type="submit" className="btn btn--primary" disabled={busy}>
            {busy ? '処理中…' : '確認する'}
          </button>
        </form>

        <div className="auth-form__links">
          <button type="button" onClick={() => void onResend()} disabled={resending}>
            {resending ? '再送中…' : 'コードを再送する'}
          </button>
        </div>
      </div>
    </div>
  );
}
